<template>
    <div class="order">
     <v-container fluid class="pa-0">
       <section  :class="$vuetify.rtl ? 'orderMenu-rtl' :'orderMenu'">
       <AppOrderMenu/>
       </section>
       <section class=" white lighten-3">
        <AppOrderFacture/>
       </section>
     </v-container>
     <AppOrderConfirm />
    </div>
</template>

<script>
import AppOrderMenu from '@/components/order/Menu.vue';
import AppOrderFacture from '@/components/order/Facture.vue';
import AppOrderConfirm from '@/components/order/ConfirmOrder.vue';

export default {
    name:'order',
    components:{
        AppOrderMenu,
        AppOrderFacture,
        AppOrderConfirm
    }
}
</script>

<style lang="scss" scoped>
    @media (min-width: 960px) {
        .orderMenu{
            margin-right: 374px;
        }
        .orderMenu-rtl{
            margin-left: 374px;
        }
    }
</style>